import { render, staticRenderFns } from "./feedback-status-label.vue?vue&type=template&id=c42f52ec"
import script from "./feedback-status-label.vue?vue&type=script&lang=js"
export * from "./feedback-status-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports